<script>
export let asset;
</script>

{#if asset.type === 'video'}
  <video controls autoPlay>
    <source src={asset.url} type="video/mp4" />
    Your browser does not support the video tag.
  </video>
{/if}

{#if asset.type === 'vimeo'}
  <div class="vimeo">
    <iframe class="content" src={asset.url} frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
  </div>
{/if}

{#if asset.type === 'image'}
  <img src={asset.url} />
{/if}

<style lang="scss">
@import '../util';

video {
  max-width: 80vw;
  max-height: 80vh;
  object-fit: contain;
}

.vimeo {
  @include aspect-ratio(16, 9);
  
  min-width: 80vw;
  max-height: 80vh;
  .content {
    pointer-events: auto;
  }
}

img {
  max-width: 80vw;
  max-height: 80vh;
  object-fit: contain;
}
</style>